import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import * as grid from 'view/styles/grid';

export const ErrorText = styled.p`
    ${fonts.small};
    margin-top: ${token('space.050', '4px')};
    color: ${token('color.text.danger', colors.R500)};
`;

export const FieldContainer = styled.div`
    margin-top: ${grid.multiple(2.25).px};
`;

export const RequiredContainer = styled.span`
    padding-left: ${token('space.025', '2px')};
    color: ${token('color.text.danger', colors.R400)};
`;
